import * as roleSchemas from './roleSchemas';
import * as roleSelectors from './roleSelectors';

import reducer from './roleReducer';

export { roleSchemas, roleSelectors };
export default reducer;
